import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";
import React, { memo, useState } from "react";
import TextError from "../../../TextError";
import {
  CloseOutlined,
  CheckOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { AutoComplete, Input, message, Modal, Select, Skeleton, Spin } from "antd";
import * as Yup from "yup";
import Autocomplete from "react-google-autocomplete";
import { useDispatch } from "react-redux";
import {
  checkblackedlist,
  loctionFromfreightify,
} from "../../../../store/SearchRates/SearchRatesSlice";
//import { REACT_APP_GOOGLE_MAP_API_KEY } from '../../../../utils/secondsToTime';

/**
 * Destination selector — mirror of OriginShipmentNew. PORT/DOOR mode comes from
 * the parent (destinationType). Added props:
 *   • multiple / maxCount — CY port field is multi-select (CY->CY, max 8),
 *     stored in destinationShipment as a "&&"-joined string.
 *   • doorToDoor — when the side is DOOR, render Door (max 3, mirrors to
 *     destinationLocation) + CY ports (max 10, UI-only).
 */
const DestinationShipmentNew = ({
  formikData,
  setAnchorEl,
  shipPorts,
  allshipports,
  destinationType,
  setDestinationType,
  destinationShipment,
  setDestinationShipment,
  destinationlocation,
  setDestinationLocation,
  multiple,
  maxCount = 8,
  doorToDoor,
}) => {
  let msg = "Country name is not equal";

  // Mirror OriginShipmentNew so origin & destination use the same DOOR field.
  const dispatch = useDispatch();
  const [locationOptions, setLocationOptions] = useState([]);

  // DOOR -> DOOR extra fields (UI only). Door mirrors to destinationLocation to
  // keep the current payload behaviour; the CY list is not sent for now.
  const [doorList, setDoorList] = useState([]);
  const [cyList, setCyList] = useState([]);
  const handleDoorChange = (vals) => {
    const capped = (vals || []).slice(0, 3);
    setDoorList(capped);
    setDestinationLocation(capped.join("&&"));
  };
  const handleCyChange = (vals) => setCyList((vals || []).slice(0, 10));

  const handleSearch = (value) => {
    dispatch(
      loctionFromfreightify({
        searchText: value,
        countryCode: "IN", // dynamic if needed
        mode: "SEA-PORT",
      })
    ).then((res) => {
      if (res?.payload?.status === 200) {
        const data = res?.payload?.data || [];
        setLocationOptions(
          data.map((item) => ({
            value: item.name,
            label: `${item.name} (${item.code})`,
          }))
        );
      } else {
        message.error("Something went wrong");
      }
    });
  };
  // const [destinationLocation, setDestinationLocation] = useState(
  //   formikData?.values?.destinationShipment?.destinationLocation
  // );
  // const [destinationLocationMarker, setDestinationLocationMarker] = useState(
  //   formikData?.values?.destinationShipment?.destinationLocationMarker
  // );
  // const [destinationLocationCountry, setDestinationLocationCountry] = useState(
  //   formikData?.values?.destinationShipment?.destinationLocationCountry
  // );
  // const [spin, setSpin] = useState(false);
  // const dispatch = useDispatch();
  // const errorModal = (msg) => {
  //   Modal.error({
  //     title: msg,
  //     onOk() {
  //       formikData.setFieldValue("originShipment.originShipment", "");
  //       formikData.setFieldValue("originShipment.originLocation", "");
  //       formikData.setFieldValue("originShipment.originPickup", "");
  //       formikData.setFieldValue("originShipment.originLocationMarker", {});
  //       formikData.setFieldValue("originShipment.originPortMarker", {});
  //       formikData.setFieldValue("originShipment.originLocationCountry", "");
  //       formikData.setFieldValue("destinationShipment.destinationShipment", "");
  //       formikData.setFieldValue("destinationShipment.destinationLocation", "");
  //       formikData.setFieldValue("destinationShipment.destinationPickup", "");
  //       formikData.setFieldValue(
  //         "destinationShipment.destinationLocationMarker",
  //         {}
  //       );
  //       formikData.setFieldValue(
  //         "destinationShipment.destinationPortMarker",
  //         {}
  //       );
  //       formikData.setFieldValue(
  //         "destinationShipment.destinationLocationCountry",
  //         ""
  //       );
  //       formikData.setFieldValue("containerDetails.incoTerms", "");
  //     },
  //     okButtonProps: {
  //       style: {
  //         color: "#ffffff",
  //         backgroundColor: "#FFAF00",
  //       },
  //     },
  //   });
  // };
  // const setFieldValuesData = (
  //   destinationShipment,
  //   destinationpickup,
  //   desiportmarker
  // ) => {
  //   setSpin(true);
  //   dispatch(checkblackedlist({ ...destinationLocationMarker }))
  //     .then((res) => {
  //       if (res?.payload?.data?.nodeData?.result === false) {
  //         errorModal(res?.payload?.data?.nodeData?.message);
  //       } else {
  //         formikData.setFieldValue(
  //           "destinationShipment.destinationShipment",
  //           destinationShipment
  //         );
  //         formikData.setFieldValue(
  //           "destinationShipment.destinationLocation",
  //           destinationLocation
  //         );
  //         formikData.setFieldValue(
  //           "destinationShipment.destinationPickup",
  //           destinationpickup
  //         );
  //         formikData.setFieldValue(
  //           "destinationShipment.destinationPortMarker",
  //           destinationLocationMarker
  //         );
  //         formikData.setFieldValue(
  //           "destinationShipment.destinationLocationMarker",
  //           destinationLocationMarker
  //         );
  //         formikData.setFieldValue(
  //           "destinationShipment.destinationLocationCountry",
  //           destinationLocationCountry
  //         );
  //       }
  //       setSpin(false);
  //       setAnchorEl(null);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };
  const onSubmit = (values, setprops) => {
    // if (values.destinationpickup && values.destinationlocation === "") {
    //   setprops.setFieldError(
    //     "destinationlocation",
    //     "Destination location is required"
    //   );
    // } else {
    //   if (
    //     formikData.values.originShipment.originShipment &&
    //     formikData.values.containerDetails.incoTerms !== ""
    //   ) {
    //     // console.log(formikData);
    //     const desiShipmentData = allshipports?.find((item) => {
    //       return (
    //         values.destinationShipment ===
    //         `${item.port_name} - (${item.port_code})`
    //       );
    //     });

    //     console.log(desiShipmentData);
    //     const originShipmentData = allshipports?.find((item) => {
    //       return (
    //         formikData.values.originShipment.originShipment ===
    //         `${item.port_name} - (${item.port_code})`
    //       );
    //     });
    //     if (
    //       (originShipmentData?.country_name?.toLowerCase() === "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() === "india") ||
    //       formikData.values.originShipment.originShipment ===
    //         values.destinationShipment
    //     ) {
    //       let msg = "";
    //       if (
    //         formikData.values.originShipment.originShipment ===
    //         values.destinationShipment
    //       ) {
    //         msg = "Shipment not allowed!";
    //       } else {
    //         msg = "Local shipment is not allowed!";
    //       }
    //       errorModal(msg);
    //     } else {
    //       if (
    //         originShipmentData?.country_name?.toLowerCase() === "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() !== "india" &&
    //         formikData.values.containerDetails.incoTerms == " "
    //       ) {
    //         console.log(
    //           "cfrd",
    //           originShipmentData?.country_name?.toLowerCase() === "india" &&
    //             desiShipmentData?.country_name?.toLowerCase() !== "india" &&
    //             formikData.values.containerDetails.incoTerms == " "
    //         );
    //         formikData.setFieldValue("containerDetails.incoTerms", "CFR");
    //         formikData.setFieldValue("containerDetails.vaslist", {
    //           originServices: [
    //             "Origin Cargo Stuffing",
    //             "Origin Transportation",
    //             "Origin Customs Clearance",
    //             "Origin CFS Clearance",
    //           ],
    //           destinationServices: [],
    //         });
    //       } else if (
    //         originShipmentData?.country_name?.toLowerCase() !== "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() === "india"
    //       ) {
    //         console.log(
    //           "fobd",
    //           originShipmentData?.country_name?.toLowerCase() !== "india" &&
    //             desiShipmentData?.country_name?.toLowerCase() === "india" &&
    //             formikData.values.containerDetails.incoTerms == " "
    //         );
    //         formikData.setFieldValue("containerDetails.incoTerms", "FOB");
    //         formikData.setFieldValue("containerDetails.vaslist", {
    //           destinationServices: [
    //             "Destination Cargo Handling",
    //             "Destination Customs Clearance",
    //             "Destination Transportation",
    //             "Destination CFS Clearance",
    //           ],
    //         });
    //       } else if (
    //         originShipmentData?.country_name?.toLowerCase() !== "india" &&
    //         desiShipmentData?.country_name?.toLowerCase() !== "india"
    //       ) {
    //         console.log(
    //           "third countryd",
    //           originShipmentData?.country_name?.toLowerCase() !== "india" &&
    //             desiShipmentData?.country_name?.toLowerCase() !== "india"
    //         );
    //         formikData.setFieldValue(
    //           "containerDetails.incoTerms",
    //           "Third Country"
    //         );
    //         formikData.setFieldValue("containerDetails.vaslist", "");
    //       }
    //       const desiportmarker = {
    //         lat: desiShipmentData?.lat,
    //         lng: desiShipmentData?.lon,
    //       };
    //       if (
    //         destinationLocationCountry &&
    //         (desiShipmentData?.country_name).toLowerCase() !==
    //           destinationLocationCountry.toLowerCase()
    //       ) {
    //         errorModal(msg);
    //       } else {
    //         console.log(desiportmarker);
    //         setFieldValuesData(
    //           values.destinationShipment,
    //           values.destinationpickup,
    //           desiportmarker
    //         );
    //       }
    //     }
    //   } else {
    //     const desiShipmentData = allshipports?.find((item) => {
    //       return (
    //         values.destinationShipment ===
    //         `${item.port_name} - (${item.port_code})`
    //       );
    //     });
    //     if (formikData.values.containerDetails.incoTerms === "") {
    //       if (desiShipmentData?.country_name?.toLowerCase() === "india") {
    //         console.log(
    //           "fobd",
    //           desiShipmentData?.country_name?.toLowerCase() === "india"
    //         );
    //         formikData.setFieldValue("containerDetails.incoTerms", "FOB");
    //         formikData.setFieldValue("containerDetails.vaslist", {
    //           destinationServices: [
    //             "Destination Cargo Handling",
    //             "Destination Customs Clearance",
    //             "Destination Transportation",
    //             "Destination CFS Clearance",
    //           ],
    //         });
    //       } else {
    //         formikData.setFieldValue("containerDetails.incoTerms", "CFR");
    //         formikData.setFieldValue("containerDetails.vaslist", {
    //           originServices: [
    //             "Origin Cargo Stuffing",
    //             "Origin Transportation",
    //             "Origin Customs Clearance",
    //             "Origin CFS Clearance",
    //           ],
    //           destinationServices: [],
    //         });
    //       }
    //     }
    //     const desiportmarker = {
    //       lat: desiShipmentData?.lat,
    //       lng: desiShipmentData?.lon,
    //     };
    //     if (
    //       destinationLocationCountry &&
    //       (desiShipmentData?.country_name).toLowerCase() !==
    //         destinationLocationCountry.toLowerCase()
    //     ) {
    //       errorModal(msg);
    //     } else {
    //       setFieldValuesData(
    //         values.destinationShipment,
    //         values.destinationpickup,
    //         desiportmarker
    //       );
    //     }
    //   }
    // }
  };
  const initialValues = {
    destinationShipment:
      formikData?.values?.destinationShipment?.destinationShipment,
    // destinationlocation: destinationLocation,
    destinationlocation: "",
    destinationpickup:
      formikData?.values?.destinationShipment?.destinationPickup,
  };
  // const validationSchema = Yup.object().shape({
  //   destinationShipment: Yup.string().required(
  //     "Please select Destination Airport"
  //   ),
  //   //destinationlocation:Yup.string().required("Destination Location is required"),
  // });
  //changes done package .json
  
  return (
    <div className="bg-white">
      <Skeleton active loading={shipPorts !== undefined ? false : true}>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          // validationSchema={validationSchema}
        >
          {(formik) => {
            return (
              <Form>
                <div className="grid grid-cols-12 gap-6">
                  {/* Flex Container for the Row */}
                  <div className="col-span-12 flex items-start gap-2">
                    {/* PORT / DOOR is now driven by the CY / DOOR toggle in the
                        parent (destinationType prop); the inline dropdown is removed. */}
                    <div className="flex-1 w-full">
                      {destinationType === "PORT" && (
                        // Ensure SelectField component has w-full and h-[42px] inside it
                        <SelectField
                          options={shipPorts}
                          formik={formik}
                          destinationShipment={destinationShipment}
                          setDestinationShipment={setDestinationShipment}
                          multiple={multiple}
                          maxCount={maxCount}
                        />
                      )}

                      {destinationType === "DOOR" && (
                        <div>
                          {/* <div className="relative">
                            <Autocomplete
                              apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
                              className="leading-4 pl-4 pr-9 py-3 focus:border focus:outline-0 block w-full text-xs font-normal border rounded-md z-[10000]"
                              placeholder="Enter Destination Location"
                              options={{
                                types: [
                                  "neighborhood",
                                  "locality",
                                  "sublocality",
                                  "postal_code",
                                  "point_of_interest",
                                ],
                                fields: [
                                  "address_components",
                                  "geometry",
                                  "icon",
                                  "name",
                                  "place_id",
                                  "formatted_address",
                                ],
                              }}
                              value={destinationLocation}
                              name="destinationlocation"
                              onChange={(e) => {
                                setDestinationLocation(e.target.value);
                                formik.setFieldValue(
                                  "destinationlocation",
                                  e.target.value
                                );
                              }}
                              onPlaceSelected={(place) => {
                                setDestinationLocation(place.formatted_address);
                                setDestinationLocationMarker({
                                  lat: place.geometry.location.lat(),
                                  lng: place.geometry.location.lng(),
                                });
                                const countryName =
                                  place.address_components.find((component) =>
                                    component.types.includes("country")
                                  ).long_name;
                                setDestinationLocationCountry(countryName);
                              }}
                            />
                            <EnvironmentOutlined className="absolute right-4 top-3 text-gray-400" />
                          </div>
                          <ErrorMessage
                            name="destinationlocation"
                            component={TextError}
                          /> */}
                          {doorToDoor ? (
                            <>
                              {/* Door locations (max 3) */}
                              <div className="relative w-full">
                                <Select
                                  mode="multiple"
                                  placeholder="Select Destination Door"
                                  onSearch={handleSearch}
                                  options={locationOptions}
                                  value={doorList}
                                  onChange={handleDoorChange}
                                  filterOption={false}
                                  bordered={false}
                                  className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border border-gray-300 rounded-md"
                                  allowClear
                                  showSearch
                                  getPopupContainer={(t) => t.parentNode}
                                />
                                <div className="text-right mt-1">
                                  <span className="sr-loc-count">
                                    {doorList.length} / 3
                                  </span>
                                </div>
                              </div>

                              {/* Nearby CY ports (max 10) — UI only for now */}
                              <div className="relative w-full mt-2">
                                <Select
                                  mode="multiple"
                                  placeholder="Select Destination CY"
                                  options={shipPorts}
                                  value={cyList}
                                  onChange={handleCyChange}
                                  optionFilterProp="label"
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  bordered={false}
                                  className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border border-gray-300 rounded-md"
                                  allowClear
                                  showSearch
                                  getPopupContainer={(t) => t.parentNode}
                                />
                                <div className="text-right mt-1">
                                  <span className="sr-loc-count">
                                    {cyList.length} / 10
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="relative w-full">
                              <AutoComplete
                                placeholder="Select Destination Door"
                                onSearch={handleSearch}
                                options={locationOptions}
                                value={destinationlocation}
                                onChange={(val) =>
                                  setDestinationLocation(val || "")
                                }
                                onSelect={(val) =>
                                  setDestinationLocation(val || "")
                                }
                                onClear={() => setDestinationLocation("")}
                                bordered={false}
                                className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border border-gray-300 rounded-md"
                                allowClear
                                showSearch
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* <div className="sm:col-span-12 col-span-6">
                    <div className="flex items-center">
                      <Field
                        type="checkbox"
                        id="destinationpickup"
                        name="destinationpickup"
                        className="w-5 h-5 rounded mx-5"
                      />
                      <label
                        htmlFor="destinationpickup"
                        className="py-2 block text-sm font-normal leading-5 text-formlabel"
                      >
                        Require delivery location at destination
                      </label>
                    </div>
                  </div>
                  <div className="sm:col-span-12 col-span-6 flex items-center sm:justify-center justify-end gap-5">
                    <button
                      type="button"
                      onClick={() => {
                        setAnchorEl(null);
                      }}
                      className="text-primary bg-white hover:bg-secondary hover:text-white font-bold leading-4 rounded-lg text-sm px-4 py-2 text-center  flex items-center justify-center gap-2 shadow-searchbox border-2 border-primary"
                    >
                      <CloseOutlined />
                      <span>Cancel</span>
                    </button>
                    <button
                      type="submit"
                      className="text-white bg-primary hover:bg-secondary font-bold leading-4 rounded-lg text-sm px-4 py-2.5 text-center  flex items-center justify-center gap-2 shadow-searchbox"
                    >
                      {spin ? (
                        <Spin />
                      ) : (
                        <>
                          <CheckOutlined />
                          <span>Confirm</span>
                        </>
                      )}
                    </button>
                  </div> */}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Skeleton>
    </div>
  );
};

const PORT_DELIM = "&&";

const SelectField = memo(
  ({
    options,
    formik,
    destinationShipment,
    setDestinationShipment,
    multiple,
    maxCount = 8,
  }) => {
    const { setFieldValue } = useFormikContext();

    // Multi-select (CY -> CY): value is the "&&"-joined string split into an
    // array; selections are capped at maxCount (antd 5.1.4 has no maxCount).
    if (multiple) {
      const selected = destinationShipment
        ? String(destinationShipment).split(PORT_DELIM).filter(Boolean)
        : [];
      const handleMultiChange = (vals) => {
        const capped = (vals || []).slice(0, maxCount);
        setDestinationShipment(capped.join(PORT_DELIM));
      };
      return (
        <Select
          mode="multiple"
          value={selected}
          onChange={handleMultiChange}
          id="destinationShipment"
          name="destinationShipment"
          showSearch
          className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border rounded-md"
          bordered={false}
          placeholder="Select Destination Shipment"
          optionFilterProp="label"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={options}
          dropdownStyle={{ zIndex: 9999 }}
        />
      );
    }

    const handleChange = (value) => {
      setDestinationShipment(value);
    };

    return (
      <>
        <Select
          value={
            destinationShipment
              ? destinationShipment
              : "Select Destination Shipment"
          }
          onChange={handleChange}
          id="destinationShipment"
          name="destinationShipment"
          showSearch
          className="py-1 leading-4 focus:border focus:outline-0 block w-full text-xs font-normal border rounded-md"
          bordered={false}
          placeholder="Select Destination Shipment"
          optionFilterProp="children"
          filterOption={(input, option) =>
            ((option?.label).toLowerCase() ?? "").includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={options}
          dropdownStyle={{ zIndex: 9999 }}
        />
        <ErrorMessage name="destinationShipment" component={TextError} />
      </>
    );
  }
);

export default React.memo(DestinationShipmentNew);
